module.exports = __webpack_public_path__ + "static/media/norte_platea.d83b9867.jpg";